((Drupal, once) => {
  Drupal.behaviors.sidebarMenu = {
    attach: (context) => {
      once('sidebarMenu', 'html', context).forEach(() => {
        const region = document.querySelector('.sidebar-first-wrapper');
        const mainNavigation = region.querySelector(
          '#block-asaa-public-main-menu-sidebar',
        );
        const sportsNavigation = region.querySelector(
          '#block-asaa-public-sportsnavigation-sidebar',
        );
        const pseudoNavigation = region.querySelector(
          '.view-championship-site-sidebar-menu',
        );
        const activeLink = region.querySelector('.is-active');
        const firstLevelLinks = region.querySelectorAll('.menu-level--0');

        // Main navigation is set to always show, so we need to hide the block when the active link is not in the menu.
        // Sports nav has a starting depth value (of 3) set, so it only shows when the current page is in the menu already.
        if (mainNavigation && sportsNavigation && activeLink) {
          if (sportsNavigation.contains(activeLink)) {
            // Sports menu active, hide main nav
            mainNavigation.classList.add('d-none');
          }
        } else if (!activeLink) {
          // No active links
          // Hide main nav if it exists
          if (mainNavigation) {
            mainNavigation.classList.add('d-none');
          }
        }

        // If active menu item is a 2nd level menu item AND has children
        // OR
        // If active menu item is a 3rd level menu item AND has children
        // OR
        // If active menu item is a 4th level menu item
        // Hide the first level and only keep "gray background" links
        if (activeLink) {
          if (
            (activeLink.parentNode.classList.contains('menu-level--1') &&
              activeLink.parentNode.querySelector('.menu-level--2')) ||
            (activeLink.parentNode.classList.contains('menu-level--2') &&
              activeLink.parentNode.querySelector('.menu-level--3')) ||
            activeLink.parentNode.classList.contains('menu-level--3')
          ) {
            firstLevelLinks.forEach((firstLevelLink) => {
              if (!firstLevelLink.classList.contains('active')) {
                firstLevelLink.classList.add('d-none');
              } else {
                firstLevelLink
                  .querySelector('.nav-link:first-of-type')
                  .classList.add('d-none');
              }
            });
          }
        }

        // Giving active menu links the .is-active class for the
        // pseudo nav (championship sites)
        if (pseudoNavigation) {
          const noClassActiveLinks = pseudoNavigation.querySelectorAll(
            `a[href = "${window.location.pathname}"]`,
          );
          noClassActiveLinks.forEach((link) => {
            link.classList.add('active-link');
          });
        }
      });
    },
  };
})(Drupal, once, this);
